
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IDocument, IDocumentCriteria } from "@tylertech/tyler-api-types";

/**
 * FormDeliveryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class FormDeliveryService {
    constructor(private readonly $apiService: ApiService) { }
    
    GenerateAndView(criteria: IDocumentCriteria): Promise<IDocument> {
        return this.$apiService.sendAuth("IFormDeliveryService/GenerateAndView", criteria);
    }
}
